import { PInlineNotification } from '@porsche-design-system/components-react';
import { type InfoMessageBoxProps } from '../default/InfoMessageBox';

const InfoMessageBox = ({ message, description }: Omit<InfoMessageBoxProps, 'icon'>) => (
    <PInlineNotification dismissButton={false} state="info">
        <span slot="heading">{message}</span>
        {description}
    </PInlineNotification>
);

export default InfoMessageBox;
